export const nonAlphanumericRegex = /[^0-9a-zA-Z]/g;
export const nonNumericRegex = /[^0-9]/g;
export const emailOTPHeadingLabel = "We just sent you a 6-digit code to your email address. Enter it here to verify your account.";
export const mobileOTPHeadingLabel = "We just sent you a 6-digit code to your mobile number. Enter it here to verify your account.";
export const unknownErrorMessage = "There was an unexpected error that may be temporary. Please try again later.";
//# sourceMappingURL=constants.js.map